import React, { Component } from 'react'
import './App.css';
import 'react-select/dist/react-select.css';

import {
    BrowserRouter as Router,
    Route,
    Switch
}
    from 'react-router-dom';

import MainContent from './components/MainContent';
import DetailView from './components/DetailView';
class App extends Component {
    render() {
        return (
            <Router>
                <Switch>
                    <Route exact={true} path="/"  component={MainContent} />
                    <Route exact path="/detail-view" component={DetailView} />
                </Switch>
            </Router>
        )
    }
}



export default App;


// WEBPACK FOOTER //
// ./src/App.js